<template>

    <main>
        <div :style="{backgroundImage: 'url(\'/image/bg1_new.jpg\' )'}">
            <vue-page-transition name="fade-in-right">
                <router-view></router-view>
            </vue-page-transition>
            <span class="float-right" hidden>{{auto_logout_timer}}</span>
        </div>
        <showChangeLogs :id="logs_id" :latest_id="latest_log_id" v-if="isOutDated && logs_id != ''" ></showChangeLogs>
    </main>
</template>

<script>

    import showChangeLogs from './pages/change-logs/showChangeLogs';
    import * as changeLogs from "./services/changeLogs.js";

    export default {
        name: "App",
        components: {
            showChangeLogs
        },
        data() {
            return {
                logs_id: '',
                latest_log_id: '',

            }
        },
        computed: {
            currentUser() {
                return this.$store.getters.currentUser
            },

            isOutDated() {
                let result = false;

                if(this.latest_log_id != ''){
                    if(Number(this.logs_id) < Number(this.latest_log_id)){
                        result = true;
                    }
                }


                return result;
            }
        },
        methods: {
            async getLatestLogs() {
                let vm = this;
                try {
                    const response = await changeLogs.getLatestLogs();
                    vm.latest_log_id = response.data;


                } catch (error) {
                }
            },
        },
        watch:{
            currentUser: async function(val){
                if(val){
                    // await this.getLatestLogs();
                    let user = await JSON.parse(localStorage.getItem('user'));
                    await this.$getUserToken(user.user.email);
                    this.$toggleTimer();
                }
            }
        },
        async mounted() {

            this.logs_id = await localStorage.getItem('change_log');

            if(this.logs_id == null){
                localStorage.setItem("change_log", 1);
                this.logs_id = await localStorage.getItem('change_log');

            }

            if(this.currentUser){
                await this.getLatestLogs();
                let user = await JSON.parse(localStorage.getItem('user'));
                await this.$getUserToken(user.user.email);
                this.$toggleTimer();
            }else{
                localStorage.setItem("expires_at", null);
                localStorage.setItem("auto_logout_timer", 0);
            }



        },
    }
</script>

